import React, { FunctionComponent } from "react";
import { Switch, Route, withRouter, RouteComponentProps } from "react-router";
import { DivisionMaster } from "./DivisionMaster";

const DivisionManagementRoutes: FunctionComponent<RouteComponentProps> = ({
  match: { url }
}) => (
  <Switch>
    <Route exact path={`${url}/`} render={() => <DivisionMaster />} />
    
  </Switch>
);

export const DivisionManagement = withRouter(DivisionManagementRoutes);